import React from 'react';
import PropTypes from 'prop-types';

import style from './ClientPanelCard.module.css';
import SingleLineData from './SingleLineData';

const ClientPanelCard = React.memo(({ data, available, first }) => {
  return available ? (
    <div className={`${style.card} ${first && style.first}`}>
      {data.map((item, idx) => {
        return (
          <SingleLineData
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            labelType={item.labelType}
            labelStyle={item.labelStyle}
            label={item.label}
            valueType={item.valueType}
            valueStyle={item.valueStyle}
            value={item.value}
            type={item.type}
          />
        );
      })}
    </div>
  ) : (
    <div>Not Available</div>
  );
});

ClientPanelCard.propTypes = {
  available: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      labelType: PropTypes.string,
      labelStyle: PropTypes.object,
      label: PropTypes.string.isRequired,
      valueType: PropTypes.string,
      valueStyle: PropTypes.object,
      value: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  first: PropTypes.bool.isRequired,
};

export default ClientPanelCard;
